module.exports = __webpack_public_path__ + "static/media/mes7.95186f38.png";